module.exports = __webpack_public_path__ + "media/images/pic/gallery/2017/matsuri-piknik-z-kultura-japonii-4dd0f1a1ebc1d92a60130d378d414277.jpg";